<template>
  <div class="" style="margin: 20px">
    <p style="font-size: 16px; font-weight: bold">
      在线填报的表单：<span>（* 号为必填表单）</span>
    </p>
    <el-table :data="list" border style="width: 100%; margin-top: 20px">
      <el-table-column width="60px" type="index" label="序号" align="center">
      </el-table-column>
      <el-table-column prop="name" label="表单名称" align="center">
        <template slot-scope="scope">
          <span style="text-align: left; display: inline-block; width: 100%"
            >{{ scope.row.name }}
            <span v-if="scope.row.type == 'true'" style="color: red">*</span>
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="state" label="提交状态" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.state">已提交</span>
          <span v-else>未提交</span>
        </template>
      </el-table-column>
      <el-table-column prop="date" label="提交截止时间" align="center">
        <!-- <template slot-scope="scope">
                            {{ scope.row.submitDeadline | moment("YYYY/MM/DD HH:mm:ss") }}
                        </template> -->
      </el-table-column>
      <el-table-column fixed="right" label="操作" align="center">
        <template slot-scope="scope">
          <span class="lookClass" @click="linkUrl(scope.row)">立即前往</span>
        </template>
      </el-table-column>
    </el-table>
    <!-- <p style="height: 20px;background-color: #f0f2f5;width: 100vw;"></p> -->
    <p
      style="
        font-size: 16px;
        height: 30px;
        line-height: 50px;
        font-weight: bold;
      "
    >
      需要下载填写再上传的表单
    </p>
    <el-table :data="list2" border style="width: 100%; margin-top: 20px">
      <el-table-column width="60px" type="index" label="序号" align="center">
      </el-table-column>
      <el-table-column prop="name" label="表单名称" align="center">
        <template slot-scope="scope">
          <span
            style="
              text-align: left;
              display: inline-block;
              width: 50%;
              float: left;
            "
            >{{ scope.row.name }}</span
          >
          <span
            v-if="scope.row.templateFileUrl"
            @click="downloadBnt(scope.row.templateFileUrl)"
            class="lookClass"
            style="margin-left: 0px"
            >点击下载</span
          >
        </template>
      </el-table-column>
      <el-table-column prop="name" label="提交状态" align="center">
        <template slot-scope="scope">
          <span v-if="!scope.row.isUpload">无需上传回执</span>
          <span v-else>
            <span v-if="scope.row.flg">已提交</span>
            <span v-else>未提交 </span>
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="submitDeadline"
        label="提交截止日期"
        align="center"
      >
        <template slot-scope="scope">
          {{ scope.row.submitDeadline | moment("YYYY/MM/DD HH:mm:ss") }}
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" align="center">
        <template slot-scope="scope">
          <span
            @click="editMember(scope.row)"
            v-if="scope.row.isUpload && !scope.row.flg"
            class="lookClass"
          >
            <!-- 点击上传 -->
            <htUpload
              ref="fileUpload"
              @save="save"
              :file-list="fileBackList"
              v-model="formInline.logo"
            />
          </span>
          <span
            v-else
            class="lookClass"
            style="color: #909399; cursor: not-allowed"
            >点击上传</span
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- <el-dialog title="上传文件" :visible.sync="showForm" width="500px">
            <el-form ref="ruleForm" :inline="true" :model="formInline" class="demo-form-inline" label-position="right"
                label-width="100px" :rules="rules">


                <el-form-item label="文件:" style="float: left;" prop="logo">

                    <htUpload ref="fileUpload" :file-list="fileBackList" v-model="formInline.logo" />

                </el-form-item>

            </el-form>
            <div style="clear:both" />
            <span slot="footer" class="dialog-footer">
                <el-button @click="showForm = false">取 消</el-button>
                <el-button type="primary" @click="save('ruleForm')">保存</el-button>
            </span>
        </el-dialog> -->
  </div>
</template>

<script>
import htUpload from "@components/uploadHt/ht-upload2";
import { mapGetters, mapActions, mapMutations } from "vuex";
export default {
  name: "exhibition-home",
  components: {
    htUpload,
  },
  data() {
    return {
      submitDeadline: null,
      item: null,
      fileBackList: [],
      showForm: false,
      formInline: {
        logo: [],
      },
      rules: {
        logo: [{ required: true, message: "请上传文件", trigger: "change" }],
      },
      list: [
        {
          date: "",
          name: "会刊免费登记表",
          state: false,
          key: "JournalFree",
          url: "/exhibition/index/exinfo/catalogue",
        },
        {
          date: "",
          name: "参展展品信息申报表",
          state: false,
          key: "Product",
          url: "/exhibition/index/exinfo/catalogue2",
        },
        {
          date: "",
          name: "展位楣板信息登记表",
          state: false,
          key: "Lintel",
          url: "/exhibition/index/exinfo/catalogue3",
        },
        {
          date: "",
          name: "参展商胸卡信息登记表",
          state: false,
          key: "Card",
          url: "/exhibition/index/exinfo/catalogue4",
        },
        {
          date: "",
          name: "会刊广告征订表",
          state: false,
          key: "JournalAdvert",
          url: "/exhibition/index/exinfo/catalogue5",
        },
        {
          date: "",
          name: "现场广告征订表",
          state: false,
          key: "SceneAdvert",
          url: "/exhibition/index/exinfo/catalogue6",
        },
        {
          date: "",
          name: "标准展台搭建变更申请表",
          state: false,
          key: "StandardBoothConstructionChange",
          url: "/exhibition/index/exinfo/catalogue7",
        },
        {
          date: "",
          name: "增租家具及电信服务一览表",
          state: false,
          key: "RentedFurnitureAndTelecommunicationsService",
          url: "/exhibition/index/exinfo/catalogue8",
        },
        {
          date: "",
          name: "展台现场拆除&安装施工价目表",
          state: false,
          key: "DemolitionBoothAndInstallationConstruction",
          url: "/exhibition/index/exinfo/catalogue9",
        },
      ],
      list2: [],
      requiredList: [],
    };
  },
  computed: {
    ...mapGetters({
      exhibitor: "loginModule/getExhibitor",
    }),
  },
  mounted() {
    this.init();
  },
  created() {},
  methods: {
    ...mapActions({
      setManageSettingQ: "hostSetModule/setManageSettingQ", //获取
      totalList: "exhibitionModule/totalList", //获取统计状态
      receiptGet: "hostSetModule/receiptGet",
      uploadReceiptrecord: "exhibitionModule/uploadReceiptrecord", //上传
      getReceiptrecord: "exhibitionModule/getReceiptrecord", //获取回执上传 状态
    }),
    async init() {
      await this.getRequired(); //获取必填
      let opt = {
        providerName: "Global",
        names: [
          "JournalFree.SubmitDeadline",
          "Product.SubmitDeadline",
          "Lintel.SubmitDeadline",
          "Card.SubmitDeadline",
          "JournalAdvert.SubmitDeadline",
          "SceneAdvert.SubmitDeadline",
          "RentedFurnitureAndTelecommunicationsService.SubmitDeadline",
          "DemolitionBoothAndInstallationConstruction.SubmitDeadline",
          "StandardBoothConstructionChange.SubmitDeadline",
        ],
      };
      let res = await this.setManageSettingQ(opt);
      if (res) {
        res.forEach((item, index) => {
          this.list[index].date = item.value;
          this.list[index].type = this.requiredList[index].value;
        });
      }

      await this.getState(); //获取状态

      await this.proDataList(); //获取回执表
    },
    //获取必填
    async getRequired() {
      let opt = {
        providerName: "Global",
        names: [
          "JournalFree.IsRequired",
          "Product.IsRequired",
          "Lintel.IsRequired",
          "Card.IsRequired",
          "JournalAdvert.IsRequired",
          "SceneAdvert.IsRequired",
          "RentedFurnitureAndTelecommunicationsService.IsRequired",
          "DemolitionBoothAndInstallationConstruction.IsRequired",
          "StandardBoothConstructionChange.IsRequired",
        ],
      };
      let res = await this.setManageSettingQ(opt);
      console.log(res, 12312312);
      if (res) {
        this.requiredList = res;

        // this.list.forEach((item,index)=>{
        //       item.type=res[index].value
        //    })
        console.log(this.list);
      }
    },

    //获取状态
    async getState() {
      let res = await this.totalList(this.exhibitor.id);
      if (res) {
        res.forEach((item, index) => {
          this.list.forEach((item1, index) => {
            if (item.key == item1.key) {
              item1.state = true;
            }
          });
        });
      }
    },
    //获取回执状态
    async getReceiptrecordState() {
      let res = await this.getReceiptrecord(this.exhibitor.id);

      if (res) {
        res.forEach((item) => {
          this.list2.forEach((item1) => {
            if (item.itemId == item1.id) {
              item1.flg = true;
            }
          });
        });
      }
    },
    //获取回执表
    async proDataList() {
      let res = await this.receiptGet();
      if (res) {
        let res1 = await this.getReceiptrecord(this.exhibitor.id); //获取回执状态
        if (res1) {
          res1.forEach((item) => {
            res.forEach((item1) => {
              if (item.itemId == item1.id) {
                item1.flg = true;
              }
            });
          });
        }
        this.list2 = res;
      }
    },
    editMember(row) {
      console.log(row, 12312312);
      // let e = JSON.stringify(row)
      // this.$router.push(`/host/index/setting/list2Detail?opt=${e}`);
      // this.showForm = true
      this.item = row;
    },
    linkUrl(row) {
      this.$router.push(row.url);
    },
    downloadBnt(e) {
      //下载
      console.log(e);
      if (e) {
        let index = e.lastIndexOf(".");
        let str = e.substring(index + 1, e.length);
        console.log(str);

        if (str == "pdf") {
          fetch(e)
            .then((response) => response.blob())
            .then((blob) => {
              // 将二进制数据转换为Blob对象
              const pdfBlob = new Blob([blob], { type: "application/pdf" });

              // 创建一个URL
              const pdfUrl = URL.createObjectURL(pdfBlob);

              // 创建一个链接元素
              const link = document.createElement("a");
              link.href = pdfUrl;
              link.download = "file.pdf";
              link.click();

              // 释放URL
              URL.revokeObjectURL(pdfUrl);
            });
        } else {
          window.open(e, "_blank");
        }
      }
    },

    validForm(formName) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[formName].validate((valid) => {
          resolve(valid);
        });
      });
    },
    async save(formName) {
      console.log(formName, "上传成功", this.item.submitDeadline);
      const timestamp = new Date(this.item.submitDeadline).getTime();
      const date = new Date(timestamp);
      const year = date.getFullYear();
      const month = ("0" + (date.getMonth() + 1)).slice(-2);
      const day = ("0" + date.getDate()).slice(-2);
      const hours = ("0" + date.getHours()).slice(-2);
      const minutes = ("0" + date.getMinutes()).slice(-2);
      const seconds = ("0" + date.getSeconds()).slice(-2);
      const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      let bool = this.regular.contrastDate(
        this.regular.compareDate(),
        formattedDate
      );
      console.log("上传成功", this.regular.compareDate(), formattedDate, bool);
      // 为true 截止日期到了 不能提交
      if (bool) {
        this.$message.warning("超过截止日期不能提交");
        return;
      }
      // const valid = await this.validForm(formName)
      // if (!valid) return
      // this.$refs[formName].resetFields() // 清空表单数据
      let opt = {
        id: this.exhibitor.id,
        body: {
          itemId: this.item.id,
          // fileName: this.formInline.logo[0].name,
          // fileUrl: this.formInline.logo[0].url,
          fileName: formName[0].name,
          fileUrl: formName[0].url,
        },
      };
      let res = await this.uploadReceiptrecord(opt);
      if (res) {
        this.$message.success("上传成功");
        this.proDataList();
        this.showForm = false;
      }
    },
  },
};
</script>

